import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess107101Status: 'idle',
    startProcess107101Error: undefined as any,
    loadUserParamsProcess107101Status: 'idle',
    loadUserParamsProcess107101Error: undefined as any,

    process107101List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess107101 = createAsyncThunk('process107101Slice/startProcess107101', async ({ process107101 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess107101/`,
        prepareData(process107101),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess107101Status } = getState().process107101Slice
        return startProcess107101Status !== 'pending'
    }
})

export const loadUserParamsProcess107101 = createAsyncThunk('process107101Slice/loadUserParamsProcess107101', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess107101/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess107101Status } = getState().process107101Slice
        return loadUserParamsProcess107101Status !== 'pending'
    }
})

const Process107101Slice = createSlice({
    name: 'process107101Slice',
    initialState,
    reducers: {
        resetstartProcess107101: (state) => {
            state.job = undefined
            state.startProcess107101Error = undefined
        },
        resetstartProcess107101Error: (state) => {
            state.startProcess107101Error = undefined
        },
        resetloadUserParamsProcess107101: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess107101Error = undefined
        },
        resetloadUserParamsProcess107101Error: (state) => {
            state.loadUserParamsProcess107101Error = undefined
        },
        removeFromProcess107101ListById: (state, action) => {
            state.process107101List = state.process107101List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess107101ListByIds: (state, action) => {
            state.process107101List = state.process107101List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process107101List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess107101Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process107101List = []
            state.startProcess107101Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess107101.pending, (state) => {
            state.startProcess107101Status = 'pending'
            state.startProcess107101Error = undefined
        })
        builder.addCase(startProcess107101.fulfilled, (state, action) => {
            state.startProcess107101Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess107101.rejected, (state, action) => {
            state.startProcess107101Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess107101Error = action.error.message
            } else {
                state.startProcess107101Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess107101.pending, (state) => {
            state.loadUserParamsProcess107101Status = 'pending'
            state.loadUserParamsProcess107101Error = undefined
        })
        builder.addCase(loadUserParamsProcess107101.fulfilled, (state, action) => {
            state.loadUserParamsProcess107101Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess107101.rejected, (state, action) => {
            state.loadUserParamsProcess107101Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess107101Error = action.error.message
            } else {
                state.loadUserParamsProcess107101Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess107101,
    resetstartProcess107101Error,
    resetloadUserParamsProcess107101,
    resetloadUserParamsProcess107101Error,
    removeFromProcess107101ListById,
    removeFromProcess107101ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process107101Slice.actions
export default Process107101Slice.reducer
